import {
    SET_ALL_PRODUCTS_TO_COLLECTION,
    TOGGLE_PRODUCT_AS_FAVOURITE
} from '../../@types/thunk.types'

const CollectionDetailsReducer = {
    [SET_ALL_PRODUCTS_TO_COLLECTION]: (state, { payload }) => {
        let styles = []
        if (payload.merge) {
            styles = [...state.response.data, ...payload.data.data]
        } else {
            styles = [...payload.data.data]
        }
        payload.data.data = styles
        state.response = payload.data
    },
    [TOGGLE_PRODUCT_AS_FAVOURITE]: (state, { payload }) => {
        state.response.data = state.response?.data?.map((item) => {
            if (item.id === payload) {
                item.liked = !item.liked
            }
            return item
        })
    }
}

export default CollectionDetailsReducer
